/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { getSubmissionErrorMessages, getFirstApplicantName } from 'shared/submission/submissionPropertyAccessor';
import { usePartiesService } from 'shared/submission/usePartiesService';
import { useTranslation } from 'react-i18next';
import { useConfiguration } from '../../../redux/features/configuration/useConfiguration';
import { ConfigResourceProps } from '../../../redux/enums/ConfigResourceProps';
import GenericCellDataAdapter from '../adapters/GenericCellDataAdapter';
import { useTheming } from '../../../shared/theming/useTheming';

export default function useTableBody(data, columnsConfiguration) {
  const { t } = useTranslation();
  const frontendCustomisationConfig = useConfiguration(ConfigResourceProps.FRONTEND_CUSTOMISATION);
  const { isPartyCompany } = usePartiesService();
  const theming = useTheming();

  const getTableBodyCellData = (flatSubmissionRow) => {
    const findFirstApplicantName = submissionData =>
      getFirstApplicantName(
        data?.filter(d => d.id === submissionData.id),
        isPartyCompany,
        t,
      );
    const submissionErrorText = getSubmissionErrorMessages(data?.find(d => d.id === flatSubmissionRow.id));

    return GenericCellDataAdapter(
      columnsConfiguration?.resource,
      frontendCustomisationConfig,
      flatSubmissionRow,
      submissionErrorText,
      findFirstApplicantName,
      t,
      theming.theme,
    );
  };

  return {
    getTableBodyCellData,
  };
}
